import React from 'react';
import { Outlet } from 'react-router-dom';

const PortNumber = () => {
  return <Outlet />;
};

export default PortNumber;
